import React from 'react';
import CartItem from './CartItem';

const CartSummary = ({ items, onCheckout, onRemove }) => {
  const total = items.reduce((sum, item) => sum + (parseFloat(item.price) || 0), 0);

  return (
    <div className="bg-white rounded-xl shadow-md p-5">
      <h3 className="text-lg font-bold text-gray-800 mb-4">Tu Pedido</h3>
      
      {items.length === 0 ? (
        <p className="text-gray-500 text-center py-4">No hay items seleccionados</p>
      ) : (
        <>
          <div className="mb-4">
            {items.map((item, idx) => (
              <CartItem key={`${item.id}-${idx}`} item={item} onRemove={onRemove} />
            ))}
          </div>
          <div className="border-t border-gray-100 pt-3 mb-4">
            <div className="flex justify-between font-semibold text-gray-800">
              <span>Total:</span>
              <span>${total.toFixed(2)}</span>
            </div>
          </div>
          <button
            onClick={onCheckout}
            className="w-full py-3 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors"
          >
            Enviar por WhatsApp
          </button>
        </>
      )}
    </div>
  );
};

export default CartSummary;